import { AxiosError } from 'axios';

import { getHeight } from '@/shared/helpers/environment/get-height';
import { getIsDev } from '@/shared/helpers/environment/get-is-dev';
import { getWidth } from '@/shared/helpers/environment/get-width';

import { BaseLogger } from './BaseLogger';
import { LogDevMessageKinds, type ServiceEvent, ServiceEventType } from './types';

export class ErrorLogger extends BaseLogger {
  static readonly errorInDevMode = this.makeLogFunction<ServiceEvent>(
    LogDevMessageKinds.error,
    (payload) => payload.message,
    ['EVENT', (event) => event]
  );

  // TODO: make one log entry with the type: error, info, api-log etc.
  // Move all variations of logs to a single class
  public static error(
    error: string | Error | AxiosError,
    place: string,
    extra: Record<string, any> = {}
  ): void {
    const payload: ServiceEvent = {
      type: ServiceEventType.ERROR,
      message: this.getErrorMessage(error),
      stacktrace: (typeof error === 'object' ? error : {}).stack ?? '',
      tags: {
        d_mod: this.predefinedOptions?.d_mod,
        d_os: this.predefinedOptions?.d_os,
        d_p: this.predefinedOptions?.d_p,
        tg_id: this.predefinedOptions?.tg_id,
        lib_n: this.predefinedOptions?.lib_n,
        lib_v: this.predefinedOptions?.lib_v,
      },
      extra: {
        loc_app: this.predefinedOptions?.loc_app,
        user_lang: this.predefinedOptions?.user_lang,
        hn: window.location.hostname,
        br_w: getWidth(),
        br_h: getHeight(),
        src: window.location.href,
        place,
        ...(error instanceof AxiosError && {
          r_url: error.config?.url,
          r_data: error.config?.data,
        }),
        ...extra,
      },
    };

    const isDev = getIsDev();

    if (isDev) {
      this.errorInDevMode(payload);
    }
  }
}
